import { gql, useLazyQuery } from '@apollo/client'
import { ModalType } from '../../../types/nextModal'

export interface BoxPlanOfferForUser {
  type: ModalType
  payload: {
    boxSizePlanOfferModalTemplate: BoxSizePlanOfferModalTemplate
  }
}

export interface BoxSizePlanOfferModalTemplate {
  planId: number
  experimentBranch: string
  mostPopularBoxId: number
  userPlanMatchBoxId: number
  boxes: BoxSize[]
}

interface BoxSize {
  id: number
  title: string
  minPrice: number
  discount: number
  mealPrice: number
  mealsPerBox: string
  planId: number
  isMostPopular: boolean
  createdAt: string
  updatedAt: string
  boxSize: string
}

export const GET_BOX_PLAN_OFFER_QUERY = gql`
  query GetBoxPlanOfferForUser($userId: Int) {
    getBoxPlanOfferForUser(userId: $userId) {
      type
      payload {
        boxSizePlanOfferModalTemplate {
          planId
          experimentBranch
          mostPopularBoxId
          userPlanMatchBoxId
          boxes {
            id
            title
            minPrice
            discount
            mealPrice
            planId
            isMostPopular
            createdAt
            updatedAt
            boxSize
          }
        }
      }
    }
  }
`

export function useGetBoxPlanOffer() {
  const [getBoxPlanOffer, { data, ...rest }] = useLazyQuery<{
    getBoxPlanOfferForUser: BoxPlanOfferForUser
  }>(GET_BOX_PLAN_OFFER_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only'
  })

  const emptyBoxPlanOffer: BoxPlanOfferForUser = {
    type: ModalType.BoxSizePlanOfferModal,
    payload: {
      boxSizePlanOfferModalTemplate: {
        planId: 0,
        experimentBranch: '',
        mostPopularBoxId: 0,
        userPlanMatchBoxId: 0,
        boxes: []
      }
    }
  }

  return {
    getBoxPlanOffer,
    boxPlanOffer: data?.getBoxPlanOfferForUser || emptyBoxPlanOffer,
    ...rest
  }
}
